import React, { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import GovFileUpload from './GovFileUpload';
import { GOV_COLORS as C, S } from './govShared';

export default function GovUploadedCostAnalyses({ solicitationId, onChanged }: {
  solicitationId: string;
  onChanged?: () => void | Promise<void>;
}) {
  const [files, setFiles] = useState<any[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setError('');
    try {
      const { data } = await api.get(`/gov/solicitations/${solicitationId}/documents`);
      setFiles((data.documents || []).filter((d: any) => d.file_type === 'cost_analysis'));
    } catch {
      setError('Unable to load uploaded cost analyses. Please retry.');
    } finally { setLoading(false); }
  }, [solicitationId]);
  useEffect(() => { void load(); }, [load]);
  return (
    <div style={{ marginBottom: 24, textAlign: 'left' }}>
      <GovFileUpload solicitationId={solicitationId} costAnalysis onUploaded={async () => { await load(); await onChanged?.(); }} />
      <p style={{ color: C.textMuted, fontSize: 13, margin: '0 0 12px' }}>
        Your original files stay available here and in Documents. Uploads do not run AI or change calculated estimate totals.
      </p>
      {loading && <div role="status" style={S.subtitle}>Loading uploaded analyses…</div>}
      {error && <div role="alert" style={{ color: C.danger }}>{error} <button style={S.cancelBtn} onClick={load}>Retry</button></div>}
      {files.map(file => (
        <div key={file.id} style={{ ...S.card, padding: '12px 16px', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 200px', minWidth: 0 }}>
            <div style={{ color: C.text, fontWeight: 700, fontSize: 13, overflowWrap: 'anywhere' }}>{file.file_name}</div>
            <div style={{ color: C.textMuted, fontSize: 12, marginTop: 4 }}>Uploaded cost analysis{file.uploaded_at ? ` · ${new Date(file.uploaded_at).toLocaleDateString()}` : ''}</div>
          </div>
          {file.storage_url && <a href={file.storage_url} target="_blank" rel="noreferrer" style={{ ...S.cancelBtn, textDecoration: 'none' }} aria-label={`Open ${file.file_name}`}>Open file ↗</a>}
        </div>
      ))}
    </div>
  );
}
